<wiz-vgroup #container wizValidationContainer class="basicInput" 
  width="100%"
  [ngClass]="{'disabled-class': wizDisabled}">
  <!-- <wiz-hgroup  width="100%" height="100%" (click)="showHidePop()" gap="0"> -->
      <wiz-text-input
      #content
      [manageModel] = false
      [wizShowLabel]="wizShowLabel"
      [wizMaxChars]="255"
      
      [wizValidator]="checkValueAvailable()"
      [wizMandatory]="wizMandatory"
     
      readonly="true"
      width="100%"
      [wizRightIcon]="getRightIcon()">
     <!-- [wizShowClearButton]="isCleanEnable()" -->
    </wiz-text-input>
  <!-- </wiz-hgroup> -->
</wiz-vgroup>
